<template>
<span></span>
</template>
<script>

export default {
    mounted () {
        let script = document.createElement('script')

        Object.keys(this.$attrs).forEach(key => {
            script.setAttribute(key, this.$attrs[key])
        })

        let text = this.$slots.default && this.$slots.default[0].text
        if (text) {
            script.innerHTML = text
        }
        document.body.appendChild(script)
    },
}
</script>
